export default __webpack_public_path__ + "media/images/images/jvqmap/globe-a2cb0e188e12ece74ab08898f1c89100.png";